import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {

  @Input() path: { label: string, link?: string }[];
  @Output() cancelAction = new EventEmitter<void>();
  @Output() continueAction = new EventEmitter<void>();
  @Input() disableButtonContinuar: boolean;
  @Input() disableButtonCancelar: boolean;
  @Input() showButtonCancelar: boolean;
  @Input() showButtonContinuar: boolean;
  @Input() titleButtonCancelar: string = 'CANCELAR';
  @Input() titleButtonContinuar: string = 'CONTINUAR';
  @Input() showBackButton: boolean = true;
  @Input() pathToGoBack?: string;

  customLogin = null;
  public statusLote: any;

  constructor(private location: Location,
              private router: Router) { }

  ngOnInit() {
    const resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  navigateTo(url: string): void {
    const decodedUrl = decodeURIComponent(url);
    const [path, queryParamsString] = decodedUrl.split('?');
    const queryParams = queryParamsString
      ? queryParamsString.split('&').reduce((params, param) => {
        const [key, value] = param.split('=');
        params[key] = value;
        return params;
      }, {})
      : {};

    this.router.navigate([path], { queryParams });
  }

  goBack() {
    if (this.pathToGoBack) {
      this.router.navigate([`/pages/${this.pathToGoBack}`]);
    } else {
      this.location.back();
    }
  }

  cancel() {
    this.cancelAction.emit();
  }

  continue() {
    this.continueAction.emit();
  }
}
